/* eslint-disable @typescript-eslint/no-explicit-any */
import { LocalDate } from 'js-joda';
import _ from 'lodash';

function isValidDate(date: string) {
  try {
    LocalDate.parse(date);
  } catch (_error) {
    return false;
  }
  return true;
}

function isValidExperienceId(experienceId: number | undefined, ticketType?: any) {
  return (
    _.isUndefined(experienceId) ||
    !_.isUndefined(ticketType) ||
    !_.isUndefined(_.find(ticketType, { id: _.toNumber(experienceId) }))
  );
}

function isValidPartySize(partySize: number | string | undefined) {
  return _.isUndefined(partySize) || _.toInteger(partySize) > 0;
}

function isValidTime(time: any) {
  // matches between 00:00 and 23:59 (requires double digits for both hours and minutes)
  const re = new RegExp('^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$');
  return re.test(time);
}

export default {
  isValidDate,
  isValidExperienceId,
  isValidPartySize,
  isValidTime,
};
